import { useMemo } from 'react';
import { rage, useObservable } from '~/rage';
import { useLayoutSelector } from '../redux';

export const useMenuLocked = () => {
	const modalNewsVisible = useLayoutSelector(
		(state) => state.modal.modalNewsVisible,
	);
	const modalOfferVisible = useLayoutSelector(
		(state) => state.modal.modalOfferVisible,
	);
	const openCaseVisible = useLayoutSelector(
		(state) => state.modal.openCaseVisible,
	);
	const openCaseRewardVisible = useLayoutSelector(
		(state) => state.modal.openCaseRewardVisible,
	);
	const modalSkillsVisible = useLayoutSelector(
		(state) => state.modal.modalSkillsVisible,
	);
	const modalChangeNameVisible = useLayoutSelector(
		(state) => state.modal.modalChangeNameVisible,
	);
	const modalChangeNamePendingVisible = useLayoutSelector(
		(state) => state.modal.modalChangeNamePendingVisible,
	);
	const modalChangeNameRejectedVisible = useLayoutSelector(
		(state) => state.modal.modalChangeNameRejectedVisible,
	);
	const modalBuyVisible = useLayoutSelector(
		(state) => state.modal.modalBuyVisible,
	);
	const menuTabsDisabled = useLayoutSelector(
		(state) => state.mainMenu.menuTabsDisabled,
	);
	const shopKitOpen = useLayoutSelector((state) => state.shop.shopKitOpen);
	const shopPlayerItemsOpen = useLayoutSelector(
		(state) => state.shop.shopPlayerItemsOpen,
	);
	const shopOpenCaseVisible = useLayoutSelector(
		(state) => state.shop.shopOpenCaseVisible,
	);
	const isOpeningCase = useLayoutSelector(
		(state) => state.mainMenu.isOpeningCase,
	);
	const confirmationVisible = useLayoutSelector(
		(state) => state.inventory.confirmationVisible,
	);
	const finishScreenVisible = useLayoutSelector(
		(state) => state.inventory.finishScreenVisible,
	);
	const modalState = useObservable(rage.modal.getCurrentModal());

	const menuLocked = useMemo(() => {
		if (modalState) {
			return true;
		}

		if (menuTabsDisabled) {
			return true;
		}

		if (
			modalNewsVisible ||
			modalOfferVisible ||
			openCaseVisible ||
			openCaseRewardVisible ||
			modalSkillsVisible ||
			modalChangeNameVisible ||
			modalChangeNamePendingVisible ||
			modalChangeNameRejectedVisible ||
			modalBuyVisible ||
			isOpeningCase ||
			confirmationVisible ||
			finishScreenVisible
		) {
			return true;
		}

		return false;
	}, [
		modalState,
		modalNewsVisible,
		modalOfferVisible,
		openCaseVisible,
		openCaseRewardVisible,
		modalSkillsVisible,
		modalChangeNameVisible,
		modalChangeNamePendingVisible,
		modalChangeNameRejectedVisible,
		menuTabsDisabled,
		modalBuyVisible,
		isOpeningCase,
		confirmationVisible,
		finishScreenVisible,
	]);

	const secondaryMenuLocked = useMemo(() => {
		if (modalState) {
			return true;
		}

		if (shopKitOpen) {
			return true;
		}

		if (shopOpenCaseVisible) {
			return true;
		}

		if (shopPlayerItemsOpen) {
			return true;
		}

		if (isOpeningCase) {
			return true;
		}

		if (
			modalNewsVisible ||
			modalOfferVisible ||
			openCaseVisible ||
			openCaseRewardVisible ||
			modalSkillsVisible ||
			modalChangeNameVisible ||
			modalChangeNamePendingVisible ||
			modalChangeNameRejectedVisible ||
			modalBuyVisible ||
			isOpeningCase
		) {
			return true;
		}

		return false;
	}, [
		shopKitOpen,
		shopOpenCaseVisible,
		modalState,
		shopPlayerItemsOpen,
		isOpeningCase,
		modalBuyVisible,
		modalChangeNameVisible,
		modalChangeNamePendingVisible,
		modalChangeNameRejectedVisible,
		modalSkillsVisible,
		modalNewsVisible,
		modalOfferVisible,
		openCaseVisible,
		openCaseRewardVisible,
	]);

	const closeMenuLocked = useMemo(() => {
		if (modalState) {
			return true;
		}

		if (
			modalNewsVisible ||
			modalOfferVisible ||
			openCaseVisible ||
			openCaseRewardVisible ||
			modalSkillsVisible ||
			modalChangeNameVisible ||
			modalChangeNamePendingVisible ||
			modalChangeNameRejectedVisible ||
			modalBuyVisible ||
			isOpeningCase
		) {
			return true;
		}

		return false;
	}, [
		modalState,
		modalNewsVisible,
		modalOfferVisible,
		openCaseVisible,
		openCaseRewardVisible,
		modalSkillsVisible,
		modalChangeNameVisible,
		modalChangeNamePendingVisible,
		modalChangeNameRejectedVisible,
		modalBuyVisible,
		isOpeningCase,
	]);

	return { menuLocked, secondaryMenuLocked, closeMenuLocked };
};
